import { render, staticRenderFns } from "./TableTh.vue?vue&type=template&id=e00136c4&scoped=true"
import script from "./TableTh.vue?vue&type=script&lang=js"
export * from "./TableTh.vue?vue&type=script&lang=js"
import style0 from "./TableTh.vue?vue&type=style&index=0&id=e00136c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00136c4",
  null
  
)

export default component.exports